<template>
  <div class="scrollable-content">
    <v-navigation-drawer
      permanent
      fixed
      expand-on-hover
      disable-resize-watcher
      hide-overlay
      app
      :mini-variant="$store.getters.openMenu"
      class="menuDrawer"
      width=360px
    >
      
      <v-list dense>
        <v-list-tile
          v-for="item in items"
          :key="item.title"
          :to="item.link"
          @click.stop ="left = !left"
        >
          <v-list-tile-action>
            <v-icon v-if="item.icon!='historico'">{{item.icon}}</v-icon>

            <a v-if="item.icon=='historico'">
              <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="25" 
              height="30" viewBox="0 0 50 50" style=" fill:#000000;">
                <g id="surface1">
                  <path style=" " d="M 6 2 L 6 46 L 32 46 L 32 44 L 8 44 L 8 4 L 42 4 L 42 28 L 44 28 L 44 2 Z M 14 11 L 14 13 L 36 13 L 36 11 Z M 14 24 L 14 26 L 18 26 L 18 24 Z M 21 24 L 21 26 L 36 26 L 36 24 Z M 14 30 L 14 32 L 18 32 L 18 30 Z M 21 30 L 21 32 L 30.183594 32 C 30.070313 31.6875 30 31.351563 30 31 C 30 30.648438 30.070313 30.3125 30.183594 30 Z M 33 30 C 32.398438 30 32 30.398438 32 31 C 32 31.601563 32.398438 32 33 32 L 34 32 L 34 35 C 34 36.398438 34.699219 37.699219 35.902344 38.699219 L 37.5 40 L 36 41.300781 C 34.699219 42.300781 34 43.5 34 45 L 34 48 L 33 48 C 32.398438 48 32 48.398438 32 49 C 32 49.601563 32.398438 50 33 50 L 49 50 C 49.601563 50 50 49.601563 50 49 C 50 48.398438 49.601563 48 48.902344 48 L 48 48 L 48 45 C 48 43.601563 47.398438 42.300781 46.097656 41.300781 L 44.597656 40 L 46.097656 38.699219 C 47.398438 37.699219 48 36.398438 48 35 L 48 32 L 49 32 C 49.601563 32 50 31.601563 50 31 C 50 30.398438 49.601563 30 49 30 Z M 36 32 L 46 32 L 46 35 C 46 35.800781 45.699219 36.5 44.902344 37.199219 L 42.5 39.199219 C 42.199219 39.398438 42.097656 39.699219 42.097656 40 C 42.097656 40.300781 42.199219 40.597656 42.5 40.699219 L 44.902344 42.800781 C 45.699219 43.5 46 44.101563 46 45 L 46 48 L 44 48 C 44 46 41 44 41 44 C 41 44 38 46 38 48 L 36 48 L 36 45 C 36 44.101563 36.398438 43.5 37.199219 42.800781 L 39.597656 40.800781 C 39.898438 40.601563 40 40.300781 40 40 C 40 39.699219 39.898438 39.402344 39.597656 39.300781 L 37.199219 37.199219 C 36.398438 36.5 36 35.800781 36 35 Z M 38 35 C 38 37.199219 41 38 41 38 C 41 38 44 37.199219 44 35 Z M 14 36 L 14 38 L 18 38 L 18 36 Z M 21 36 L 21 38 L 32.777344 38 C 32.433594 37.367188 32.203125 36.695313 32.09375 36 Z ">
                  </path>
                </g>
              </svg>
            </a>
            

          <!-- <v-icon v-if="item.icon!='historico'">home</v-icon>

            <a v-if="item.icon=='relatorios'" color="info" > 
            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
              width="26" height="26"
              viewBox="0 0 192 192"
             style=" fill:#000000;">
             <g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,192v-192h192v192z" fill="none"></path><g fill="#2ecc71">
             <path d="M96,24l-80,16v112l80,16zM112,40v16h16v16h-16v16h16v16h-16v16h16v16h-16v16h56c4.416,0 8,-3.584 8,-8v-96c0,-4.416 -3.584,-8 -8,-8zM144,56h16v16h-16zM33.40625,66.375h14.21875l7.39062,17.71875c0.6,1.448 1.05163,3.12725 1.51562,5.03125h0.20313c0.264,-1.144 0.80138,-2.89187 1.60938,-5.17187l8.23437,-17.57813h12.96875l-15.48438,29.35938l15.9375,29.89062h-13.82812l-8.90625,-19.3125c-0.336,-0.68 -0.7345,-2.04912 -1.0625,-3.95312h-0.125c-0.2,0.912 -0.60312,2.27738 -1.20312,4.10938l-8.98438,19.15625h-13.89062l16.48438,-29.65625zM144,88h16v16h-16zM144,120h16v16h-16z">
            </path>
            </g></g>
             </svg>
            </a> -->

            <!-- <a v-if="item.icon=='relatorios'" > 
            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
              width="48" height="48"
              viewBox="0 0 24 24"
              style=" fill:#000000;">
              <path d="M 14 2 L 6 2 C 4.894531 2 4 2.894531 4 4 L 4 20 C 4 21.105469 4.894531 22 6 22 L 18 22 C 19.105469 22 20 21.105469 20 20 L 20 8 Z M 11 20 L 7 20 L 7 18 L 11 18 Z M 11 17 L 7 17 L 7 15 L 11 15 Z M 11 14 L 7 14 L 7 12 L 11 12 Z M 17 20 L 13 20 L 13 18 L 17 18 Z M 17 17 L 13 17 L 13 15 L 17 15 Z M 17 14 L 13 14 L 13 12 L 17 12 Z M 13 9 L 13 3.5 L 18.5 9 Z"></path></svg>
            </a> -->
           <!-- <v-icon v-if="item.icon!='historico'">{{item.icon}}</v-icon> -->

          <!-- <a v-if="item.icon=='relatorios'" > 
            <g id="surface1">
            <svg style="width:24px;height:24px" viewBox="0 0 24 24">
              <path fill="currentColor" d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M15.8,20H14L12,16.6L10,20H8.2L11.1,15.5L8.2,11H10L12,14.4L14,11H15.8L12.9,15.5L15.8,20M13,9V3.5L18.5,9H13Z" />
            </svg>
            </g>
          </a> -->



           <!-- <v-flex xs4 sm2 md1 p-t-15>   -->
              <!-- <a  v-if="item.icon=='relatorios'" color="info" >
                  <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                width="30" height="30"
                viewBox="0 0 192 192"
                style=" fill:#000000;">
                <g fill="none" fill-rule="nonzero" stroke="none" stroke-width="10" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal">
                  <path d="M0,192v-192h192v192z" fill="none">
                </path>
                <g fill="#2ecc71">
                  <path d="M96,24l-80,16v112l80,16zM112,40v16h16v16h-16v16h16v16h-16v16h16v16h-16v16h56c4.416,0 8,-3.584 8,-8v-96c0,-4.416 -3.584,-8 -8,-8zM144,56h16v16h-16zM33.40625,66.375h14.21875l7.39062,17.71875c0.6,1.448 1.05163,3.12725 1.51562,5.03125h0.20313c0.264,-1.144 0.80138,-2.89187 1.60938,-5.17187l8.23437,-17.57813h12.96875l-15.48438,29.35938l15.9375,29.89062h-13.82812l-8.90625,-19.3125c-0.336,-0.68 -0.7345,-2.04912 -1.0625,-3.95312h-0.125c-0.2,0.912 -0.60312,2.27738 -1.20312,4.10938l-8.98438,19.15625h-13.89062l16.48438,-29.65625zM144,88h16v16h-16zM144,120h16v16h-16z"></path></g></g></svg>
              </a> -->
           <!-- </v-flex> -->

            <!-- <a v-if="item.icon=='relatorios'" color="info"> -->
              <!-- <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
              width="25" height="30"
              viewBox="0 0 50 50">
              <g>
                <path d="M0,192v-192h192v192z" fill="none"></path>
                <g fill="#2ecc71">
                  <path d="M96,24l-80,16v112l80,16zM112,40v16h16v16h-16v16h16v16h-16v16h16v16h-16v16h56c4.416,0 8,-3.584 8,-8v-96c0,-4.416 -3.584,-8 -8,-8zM144,56h16v16h-16zM33.40625,66.375h14.21875l7.39062,17.71875c0.6,1.448 1.05163,3.12725 1.51562,5.03125h0.20313c0.264,-1.144 0.80138,-2.89187 1.60938,-5.17187l8.23437,-17.57813h12.96875l-15.48438,29.35938l15.9375,29.89062h-13.82812l-8.90625,-19.3125c-0.336,-0.68 -0.7345,-2.04912 -1.0625,-3.95312h-0.125c-0.2,0.912 -0.60312,2.27738 -1.20312,4.10938l-8.98438,19.15625h-13.89062l16.48438,-29.65625zM144,88h16v16h-16zM144,120h16v16h-16z">
                  </path>
                </g>
              </g>
              <g id="surface1">
                  <path style=" " d="M 6 2 L 6 46 L 32 46 L 32 44 L 8 44 L 8 4 L 42 4 L 42 28 L 44 28 L 44 2 Z M 14 11 L 14 13 L 36 13 L 36 11 Z M 14 24 L 14 26 L 18 26 L 18 24 Z M 21 24 L 21 26 L 36 26 L 36 24 Z M 14 30 L 14 32 L 18 32 L 18 30 Z M 21 30 L 21 32 L 30.183594 32 C 30.070313 31.6875 30 31.351563 30 31 C 30 30.648438 30.070313 30.3125 30.183594 30 Z M 33 30 C 32.398438 30 32 30.398438 32 31 C 32 31.601563 32.398438 32 33 32 L 34 32 L 34 35 C 34 36.398438 34.699219 37.699219 35.902344 38.699219 L 37.5 40 L 36 41.300781 C 34.699219 42.300781 34 43.5 34 45 L 34 48 L 33 48 C 32.398438 48 32 48.398438 32 49 C 32 49.601563 32.398438 50 33 50 L 49 50 C 49.601563 50 50 49.601563 50 49 C 50 48.398438 49.601563 48 48.902344 48 L 48 48 L 48 45 C 48 43.601563 47.398438 42.300781 46.097656 41.300781 L 44.597656 40 L 46.097656 38.699219 C 47.398438 37.699219 48 36.398438 48 35 L 48 32 L 49 32 C 49.601563 32 50 31.601563 50 31 C 50 30.398438 49.601563 30 49 30 Z M 36 32 L 46 32 L 46 35 C 46 35.800781 45.699219 36.5 44.902344 37.199219 L 42.5 39.199219 C 42.199219 39.398438 42.097656 39.699219 42.097656 40 C 42.097656 40.300781 42.199219 40.597656 42.5 40.699219 L 44.902344 42.800781 C 45.699219 43.5 46 44.101563 46 45 L 46 48 L 44 48 C 44 46 41 44 41 44 C 41 44 38 46 38 48 L 36 48 L 36 45 C 36 44.101563 36.398438 43.5 37.199219 42.800781 L 39.597656 40.800781 C 39.898438 40.601563 40 40.300781 40 40 C 40 39.699219 39.898438 39.402344 39.597656 39.300781 L 37.199219 37.199219 C 36.398438 36.5 36 35.800781 36 35 Z M 38 35 C 38 37.199219 41 38 41 38 C 41 38 44 37.199219 44 35 Z M 14 36 L 14 38 L 18 38 L 18 36 Z M 21 36 L 21 38 L 32.777344 38 C 32.433594 37.367188 32.203125 36.695313 32.09375 36 Z ">
                  </path>
              </g>
              </svg> -->

              <!-- <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                width="24" height="24"
                 viewBox="0 0 24 24"
              style=" fill:#000000;">
              <g id="surface1">
              <path d="M 12 3 L 2 5 L 2 19 L 12 21 L 12 3 z M 14 5 L 14 7 L 16 7 L 16 9 L 14 9 L 14 11 L 16 11 L 16 13 L 14 13 L 14 15 L 16 15 L 16 17 L 14 17 L 14 19 L 21 19 C 21.552 19 22 18.552 22 18 L 22 6 C 22 5.448 21.552 5 21 5 L 14 5 z M 18 7 L 20 7 L 20 9 L 18 9 L 18 7 z M 4.1757812 8.296875 L 5.953125 8.296875 L 6.8769531 10.511719 C 6.9519531 10.692719 7.0084063 10.902625 7.0664062 11.140625 L 7.0917969 11.140625 C 7.1247969 10.997625 7.1919688 10.779141 7.2929688 10.494141 L 8.3222656 8.296875 L 9.9433594 8.296875 L 8.0078125 11.966797 L 10 15.703125 L 8.2714844 15.703125 L 7.1582031 13.289062 C 7.1162031 13.204062 7.0663906 13.032922 7.0253906 12.794922 L 7.0097656 12.794922 C 6.9847656 12.908922 6.934375 13.079594 6.859375 13.308594 L 5.7363281 15.703125 L 4 15.703125 L 6.0605469 11.996094 L 4.1757812 8.296875 z M 18 11 L 20 11 L 20 13 L 18 13 L 18 11 z M 18 15 L 20 15 L 20 17 L 18 17 L 18 15 z">
              </path>
              </g>
              </svg>

              <v-icon>home</v-icon>
              <v-icon>grid_view</v-icon>
              
            </a> -->
          

          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title v-text="item.title" color="default"></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>    
      <!--{{ dadosFornecedor }} -->
      <!-- Resumo de Dados -->
      <ResumoDados
        :tipoFornecedor="dadosFornecedor.tipoFornecedor"
        :documento="dadosFornecedor.numCgcFornecedor"
        :showResumoDados="!this.drawer"
        :cnpj="dadosFornecedor.numCgcFornecedor"
        :razaoSocial="dadosFornecedor.dscRazaoSocial"
        :cep="dadosFornecedor.numCep"
        :logradouro="dadosFornecedor.dscLogradouro"
        :complemento="dadosFornecedor.dscComplemento"
        :numero="dadosFornecedor.numEndereco"
        :bairro="dadosFornecedor.dscBairro"
        :cidade="dadosFornecedor.dscCidade"
        :id-solicitacao="dadosFornecedor.idFornecSolicitacao || dadosFornecedor.idfornecSolicitacao || $route.params.id"
        v-if="whattAba && (
            whattAba === 'tab-hab-juridica' || 
            whattAba === 'tab-familia' ||
            whattAba === 'tab-qualificacaoTecnica' ||
            whattAba === 'tab-regularidadeFiscal' ||
            whattAba === 'tab-qualificacao' ||
            whattAba === 'tab-formulariosDeclaracoes'
          )"
        @visualizar-cartao-cnpj="handleVisualizarCartaoCnpj"
      >
      </ResumoDados>
      <!-- / Resumo de Dados -->

      <!-- Calculadora de prazo -->      
      <Calculadora 
        :showCalcProp = '!this.drawer'
        :LimpaCampos = whattLimpa
        v-if="(whattAba === 'tab-regularidadeFiscal') || (whattAba === 'tab-qualificacao')"
      >
      </Calculadora>
      <!-- / Calculadora de prazo -->
        
    </v-navigation-drawer>
  </div>
</template>

<script>
import Calculadora from "./calculadora";
import ResumoDados from "../feature/area-restrita/fornecedor/resumo-dados.vue";
import regularidadeFiscTrabService from "../services/regularidadeFiscTrabService";
import baseService from "../../src/services/baseService"

export default {
  components: { /*Componentes utilizados*/
      Calculadora,
      ResumoDados
  },
  name: "menuRestrito",
  props: {//Propriedades que o objeto recebe como parametro
    drawer: Boolean
  },
  data: () => ({
    left: null,
    mini: false,
    items: [],
    idSolicitacaoAtual: null // ✅ NOVA VARIÁVEL PARA GUARDAR O ID
  }),

created: function() {
  this.itensMenu();
  
  var self = this;
  
  this.$root.$on('id-solicitacao-disponivel', function(id) {
    self.idSolicitacaoAtual = id;
    sessionStorage.setItem('idFornecSolicitacao', String(id));    
  });
},

beforeDestroy: function() {
  this.$root.$off('id-solicitacao-disponivel');
},
 
  computed: {  // Campos computados
   whattAba() {
        if (this.$store && this.$store.getters && this.$store.getters.activeAba) {
          return this.$store.getters.activeAba;
        }
        return null;
      },
    whattLimpa() {
      return this.$store.getters.CalcLimpa
    },
    drawerFlag: {
      get: function() {
        return this.drawer;
      },
      set: function(val) {
        this.$emit("emitterdrawer", val);
      }
    },
    mostrarResumoDados() {  // Agora DENTRO do objeto computed!
      // Exibir nas abas específicas mencionadas
      const abasResumoDados = [
        'tab-hab-juridica',         // Habilitação Jurídica
        'tab-familia',              // Família  
        'tab-qualificacaoTecnica',  // Qualificação Técnica
        'tab-regularidadeFiscal',   // Regularidade Fiscal e Trabalhista
        'tab-qualificacao',         // Qualificação Econômico-Financeira
        'tab-formulariosDeclaracoes'// Formulários e Declarações
      ];
      
      return abasResumoDados.includes(this.whattAba);
    },
  
    dadosFornecedor() {
      // Busca os dados do fornecedor da store
      return this.$store.getters.fornecedorAtivo || {
        numCgcFornecedor: '',
        dscRazaoSocial: '',
        numCep: '',
        dscLogradouro: '',
        dscComplemento: '',
        numEndereco: '',
        dscBairro: '',
        dscCidade: ''
      };
    }
  },
  destroyed() {  // Hook do ciclo de vida, no nível correto
    this.$store.commit("setAba", {
      abaAtiva: "tab-dados"
    });
  },

  methods:{
    carregarDadosFornecedor() {
    if (this.$route.params.id) {
      this.$store.dispatch('carregarDadosFornecedor', this.$route.params.id);
    }
  },

    itensMenu(){
      if (this.$verificaPerfilSomenteHabilitador()) {
        this.items = [
          { 
            title: "Dashboard",
            link: "/arearestrita/habilitador/dashboard",
            icon:"dashboard"
          },
          {
            title: "Termo de Concordância e Veracidade",
            link: "/arearestrita/habilitador/veracidade",
            icon:"task_alt"
          },
          { 
            title: "Validação", 
            link: "/arearestrita/habilitador/solicitacao",
            icon:"spellcheck"
          },
          {
            title: "Consultar Solicitação",
            link: "/arearestrita/habilitador/consulta-cadastro",
            icon:"search" 
          },
          {
            title: "Guias e Orientações",
            link: "/guias-orientacoes",
            icon:"description",
          },
          { 
            title: "Gestão de Acesso", 
            link: "/gestao-acesso",
            icon:"lock" 
          },
        ];
      }else if(this.$verificaPerfilHabilitadorMaster()){
        this.items = [
          { 
            title: "Dashboard Master",
            link: "/arearestrita/habilitador/dashboard",
            icon:"dashboard"
          },
          {
            title: "Termo de Concordância e Veracidade",
            link: "/arearestrita/habilitador/veracidade",
            icon:"task_alt"
          },
          { 
            title: "Validação", 
            link: "/arearestrita/habilitador/solicitacao",
            icon:"spellcheck"
          },
          {
            title: "Consultar Solicitação",
            link: "/arearestrita/habilitador/consulta-cadastro",
            icon:"search" 
          },
          {
            title: "Dupla Conferência",
            link: "/arearestrita/habilitador/dupla-conferencia",
            icon:"done_all" 
          },
          {
            title: "Guias e Orientações",
            link: "/guias-orientacoes",
            icon:"description",
          },
          // Novo menu de Gestão de acesso
          { 
            title: "Gestão de Acesso", 
            link: "/gestao-acesso",
            icon:"lock" 
          },
         { 
            title: "Relatórios", 
            link: "/relatorios",
            icon:"receipt_long" 
          },
        ];
      }
      else if(this.$verificaPerfilCadastrador()){
        this.items = [
          {
            title: "Histórico de Solicitações",
            link: "/arearestrita/cadastrador/solicitacao",
            icon:"search"
          },
          {
            title: "Cadastrar Fornecedor",
            link: "/arearestrita/cadastrador/cadastrarnovo",
            icon:"task_alt"
          },
          { 
            title: "Atualizar Fornecedor", 
            link: "/arearestrita/habilitador/consulta-cadastro",
            icon:"spellcheck"
          },         
          {
            title: "Guias e Orientações",
            link: "/guias-orientacoes",
            icon:"description",
          },
          { 
            title: "Gestão de Acesso", 
            link: "/gestao-acesso",
            icon:"lock" 
          },
        ];
      }
      else {
        this.items = [
          
          {
            title: "PCEs Disponíveis",
            link: "/fornecedor-painel",
            icon:"account_balance"
          },
          {
            title: "Extrato", 
            link: "/extrato",
            icon:"assignment"
          },
          { 
            title: "Documentos Vencidos", 
            link: "/documentos-vencidos",
            icon:"notification_important"
          },
          { 
            title: "Solicitações", 
            link: "/historico-solicitacoes",
            icon:"historico" 
          },
          {
            title: "Guias e Orientações",
            link: "/guias-orientacoes",
            icon:"description",
          },
          { 
            title: "Gestão de Acesso", 
            link: "/gestao-acesso",
            icon:"lock" 
          },
        ];
      }
    },
    handleVisualizarCartaoCnpj: function(payload) {
      var self = this;
      self.$store.commit("preload", true);

      var idSolicitacao = null;

      // 🔍 1. sessionStorage (salvo pelo regularidade-fiscal.vue)
      idSolicitacao = sessionStorage.getItem('idFornecSolicitacao');

      // 🔍 2. Payload do componente ResumoDados
      if (!idSolicitacao && payload && payload.id) {
        idSolicitacao = payload.id;
      }

      // 🔍 3. Busca na Vuex Store (incluindo chave com underscore)
      if (!idSolicitacao && self.$store && self.$store.state) {
        var state = self.$store.state;
        
        // Tenta state.solicitacao
        if (state.solicitacao) {
          idSolicitacao = state.solicitacao.idfornec_solicitacao || 
                         state.solicitacao.idFornecSolicitacao;
        }
        // Tenta state.fornecedor
        if (!idSolicitacao && state.fornecedor) {
          idSolicitacao = state.fornecedor.idfornec_solicitacao || 
                         state.fornecedor.idFornecSolicitacao;
        }
        // Tenta state.model
        if (!idSolicitacao && state.model) {
          idSolicitacao = state.model.idfornec_solicitacao || 
                         state.model.idFornecSolicitacao;
        }
      }

      // 🔍 4. Busca nos getters (incluindo underscore)
      if (!idSolicitacao && self.$store && self.$store.getters) {
        var getters = self.$store.getters;
        
        if (getters.fornecedorAtivo) {
          idSolicitacao = getters.fornecedorAtivo.idfornec_solicitacao || 
                         getters.fornecedorAtivo.idFornecSolicitacao;
        }
        if (!idSolicitacao && getters.solicitacaoAtual) {
          idSolicitacao = getters.solicitacaoAtual.idfornec_solicitacao || 
                         getters.solicitacaoAtual.idFornecSolicitacao;
        }
      }

      // 🔍 5. Último fallback: rota
      if (!idSolicitacao && self.$route && self.$route.params && self.$route.params.id) {
        idSolicitacao = self.$route.params.id;
      }

      // Validação final
      if (!idSolicitacao) {
        self.$toasted.error("ID da solicitação não encontrado.");
        self.$store.commit("preload", false);
        
        console.error('❌ FALHA: ID não encontrado', {
          sessionStorage: sessionStorage.getItem('idFornecSolicitacao'),
          payloadId: payload ? payload.id : null,
          storeState: self.$store ? self.$store.state : null
        });
        return;
      }

      // Chamada ao serviço
      regularidadeFiscTrabService.getDocumentosRegularidade(idSolicitacao)
        .then(function(response) {
          var documentos = Array.isArray(response.data) ? response.data : [];
          var documentoCNPJ = null;
          
          for (var i = 0; i < documentos.length; i++) {
            if (documentos[i].tipDocumento === 1) {
              documentoCNPJ = documentos[i];
              break;
            }
          }
          
          if (documentoCNPJ && documentoCNPJ.arquivoUpload) {
            baseService.abrirArquivo(documentoCNPJ.arquivoUpload, self.dadosFornecedor.numCgcFornecedor);
          } else {
            self.$toasted.error("Cartão CNPJ não encontrado ou não anexado.");
          }
        })
        .catch(function(error) {
          console.error("Erro ao buscar cartão CNPJ:", error);
          self.$toasted.error("Falha na comunicação com o servidor");
        })
        .finally(function() {
          self.$store.commit("preload", false);
        });
    },

    handleIconClick(arquivo) {
    if (arquivo.includes('https')) {
      window.open(arquivo, '_blank');
    } else if (arquivo.includes('.pdf')) {
      this.baixarArquivo(arquivo);
    }
  },
 
  baixarArquivo(arquivo, numCgcFornecedor) {
    const store = this.$store;
  
      // 1. Verificar se é URL externa
      if (/^(http|https):\/\//i.test(arquivo)) {
        window.open(arquivo, '_blank');
        return;
      }

      // 2. Usar a instância configurada do Axios
      instance.post('arquivo/file', {
        file: arquivo,
        numCgcFornecedor: numCgcFornecedor ? numCgcFornecedor.replace(/\D/g, '') : null // Remove não-dígitos
      }, {
        responseType: 'blob'
      }).then(response => {
        // 3. Criar Blob e abrir em nova guia
        const blob = new Blob([response.data], { 
          type: response.headers['content-type'] || 'application/pdf' 
        });
        const url = window.URL.createObjectURL(blob);
        window.open(url, '_blank');
      }).catch(error => {
        console.error('Erro:', error);
        Vue.toasted.error("Falha ao abrir documento");
      });
    },
  },
  // Adicionar um watcher para observar mudanças na aba ativa
  watch: {
    whattAba(novaAba) {
      if (novaAba === 'tab-dados') {
        this.carregarDadosFornecedor();
      }
    }
  },

  // Carregar dados ao montar o componente
  mounted() {
    this.carregarDadosFornecedor();
  } 
};
</script>